import { render, staticRenderFns } from "./ProfilePhotoTab.vue?vue&type=template&id=46e336a8&"
import script from "./ProfilePhotoTab.vue?vue&type=script&lang=js&"
export * from "./ProfilePhotoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports